import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 30px 30px 90px;
  min-width: 0;
  @media (max-width: 767px) {
    padding: 20px 16px 90px;
  }
  background: var(--color-surface);
  border-radius: 20px;
  width: 640px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 30px;
  color: var(--color-text);
  @media (max-width: 1455px) {
    width: 100%;
  }

  .form-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    color: var(--color-text);
  }

  h4 {
    font-weight: 600;
    font-size: 20px;
    line-height: 130%;
    text-align: left;
    color: var(--color-text);
    span {
      font-weight: 500;
    }
  }

  h5 {
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: var(--color-text-muted);
  }

  .line {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;

    button {
      white-space: normal;
      width: 130px;
    }
  }

  .check-button {
    min-height: 44px;
    height: auto;
    padding: 6px 2px;
    border-radius: 5px;
    border: 1px solid var(--color-accent);
    background: transparent;
    color: var(--color-text);

    &:hover {
      border: 1px solid var(--color-accent);
      color: var(--color-text);
    }

    &.active {
      background: var(--color-link);
      border: 1px solid var(--color-link);
      color: var(--color-surface);
    }
  }

  button.primary {
    width: 130px;
    min-height: 44px;
    height: auto;
    position: absolute;
    bottom: 30px;
    right: 30px;
  }
`;
